<a routerLink="/login" class="logo">My Event Pass</a><br> 
<div class="floatingTile">

    <h1  class="center">Ausgeloggt</h1>
    <p>Sie wurden erfolgreich ausgeloggt.</p>
    <p><a routerLink="/login">zurück zum Login</a></p>
    
</div>
